import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState
} from 'react'

import QRCode, { PopUpoShowTQRCodeProps } from '@/components/QRCode'
import { LINKS } from '@/constants/links'

export type QRCodeDrawerContextType = {
  toggleDrawer: () => void
  qrCodeModelValue: (value: PopUpoShowTQRCodeProps) => void
  setQRCodelink: Dispatch<SetStateAction<string>>
}

const QRCodeDrawerContextDefaultValues: QRCodeDrawerContextType = {
  toggleDrawer: () => undefined,
  qrCodeModelValue: () => undefined,
  setQRCodelink: () => ''
}

export const QRCodeDrawerContext = createContext<QRCodeDrawerContextType>(
  QRCodeDrawerContextDefaultValues
)

export const useQRCodeDrawer = (): QRCodeDrawerContextType => {
  return useContext(QRCodeDrawerContext)
}

export const QRCodeDrawerProvider: React.FC<{ children: ReactNode }> = ({
  children
}) => {
  const [isVisible, setIsVisible] = useState<boolean>(false)

  const [QRCodelink, setQRCodelink] = useState<string>('')
  const [popUpToShow, setPopUpToShow] = useState<PopUpoShowTQRCodeProps>('none')

  const toggleDrawer = () => {
    setIsVisible((value) => !value)
  }

  const qrCodeModelValue = (valueQR: PopUpoShowTQRCodeProps) => {
    setPopUpToShow(valueQR)
  }
  return (
    <>
      <QRCodeDrawerContext.Provider
        value={{
          toggleDrawer,
          setQRCodelink,
          qrCodeModelValue
        }}
      >
        <>
          <QRCode
            isShowing={isVisible}
            onToggle={toggleDrawer}
            QRCodelink={QRCodelink || LINKS.APP_LINK}
            popUpToShow={popUpToShow}
          />
          {children}
        </>
      </QRCodeDrawerContext.Provider>
    </>
  )
}
